import React from 'react';
import { BuilderContent, BuilderComponent } from '@builder.io/react/lite';

import FAQ from '@glowforge/gf-styled/src/components/faq';
import builderPathInit from '../../util/builder-path-init';

// set up builder and register custom components
builderPathInit({
  model: 'faq',
  pathPrefix: 'b/faq-preview',
  noIndex: true,
});

/**
 * FAQ Preview is for previewing individual FAQs. This allows the FAQ component
 * in builder.io to have questions with dynamic answers. Additionally, it allows
 * for the reuse of FAQ components in lists.
 */
function FAQPreview() {
  return (
    <>
      <ul>
        <li>
          {`Note that this is a preview. The "open" action of the FAQ will be kind of janky,
          as it is loading the answer to this question dynamically.`}
        </li>
        <li>The question text is located in the &quot;Options&quot; menu.</li>
      </ul>
      <BuilderContent model='faq-section'>
        {(data, loading) => {
          if (loading) return <p>loading</p>;
          return (
            <FAQ
              openAll
              items={[
                {
                  question: data.question,
                  answer: (
                    <BuilderComponent content={data} model='faq-section' />
                  ),
                },
              ]}
            />
          );
        }}
      </BuilderContent>
    </>
  );
}

export default FAQPreview;
